import { render, staticRenderFns } from "./commonView.vue?vue&type=template&id=056fffef&scoped=true"
import script from "./commonView.vue?vue&type=script&lang=js"
export * from "./commonView.vue?vue&type=script&lang=js"
import style0 from "./commonView.vue?vue&type=style&index=0&id=056fffef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056fffef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056fffef')) {
      api.createRecord('056fffef', component.options)
    } else {
      api.reload('056fffef', component.options)
    }
    module.hot.accept("./commonView.vue?vue&type=template&id=056fffef&scoped=true", function () {
      api.rerender('056fffef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/entry/components/commonView.vue"
export default component.exports